import React from "react";

function Header({ title }) {
  return <h2>{title} - bilalafzal</h2>;
}

export default Header;
